import { Action } from 'redux';
import { initializeState } from 'src/utils/Initial';
import { isType } from 'typescript-fsa';
import * as Actions from '../actions/whatsNewDetail';

/**
 * メッセージ一覧のState型
 */
export interface IWhatsNewDetailState {
	readonly whatsNews: Actions.IWHatsNew[];
}

/**
 * メッセージ一覧のState初期値
 */
const initialState: IWhatsNewDetailState = {
	whatsNews: [],
};

/**
 * メッセージ一覧用reducer
 * @param state State
 * @param action アクション
 */
const messageDetails = (state: IWhatsNewDetailState, action: Action) => {
	if (!state) {
		// State初期化処理
		state = initialState;
		state = initializeState(state);
	}
	if (isType(action, Actions.setWhatsNewList)) {
		return {
			...state,
			whatsNews: action.payload.whatsNews,
		};
	}

	if (isType(action, Actions.clearWhatsNewList)) {
		return initialState;
	}

	return state;
};

export default messageDetails;



// WEBPACK FOOTER //
// ./src/reducers/WhatsNewDetail.ts